import { render, staticRenderFns } from "./TaxButton.vue?vue&type=template&id=57829e7c&scoped=true&"
import script from "./TaxButton.vue?vue&type=script&lang=js&"
export * from "./TaxButton.vue?vue&type=script&lang=js&"
import style0 from "./TaxButton.vue?vue&type=style&index=0&id=57829e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57829e7c",
  null
  
)

export default component.exports